"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    maxSelectedSix: {
        en: "You can't select more then 6 Maps.",
        es: "Solo puedes seleccionar un máximo de 6 Mapas.",
    },
    controlPanel: {
        en: "Control Panel",
        es: "Panel de Control",
    },
    placesPanel: {
        en: "Geofences",
        es: "Geocercas",
    },
    lastReport: {
        en: "Last Report",
        es: "Ultimo Reporte",
    },
    lastEvent: {
        en: "Last Event ",
        es: "Ultimo Evento",
    },
    lastEvents: {
        en: "Last Events ",
        es: "Ultimos Eventos",
    },
    from: {
        en: "From",
        es: "Desde",
    },
    to: {
        en: "To",
        es: "Hasta",
    },
    altitud: {
        en: "Altitud",
        es: "Altitud",
    },
    autoRefresh: {
        en: "Auto Update",
        es: "Auto Refrescar",
    },
    otherUnits: {
        en: "Other Units",
        es: "Otras Unidades",
    },
    traffic: {
        en: "Traffic",
        es: "Trafico",
    },
    ruler: {
        en: "Ruler",
        es: "Regla",
    },
    time: {
        en: "Time",
        es: "Hora",
    },
    signal: {
        en: "Signal",
        es: "Señal",
    },
    createPoi: {
        en: "Convert to Point Of Interest",
        es: "Convertir a Punto de interés",
    },
    batery: {
        en: "Battery",
        es: "Batería",
    },
    event: {
        en: "Event",
        es: "Evento",
    },
    noEvents: {
        en: "No event reported today",
        es: "No hay reportes de eventos hoy.",
    },
    futureDates: {
        en: "You have selected a future date, you have been sent back to the last date you entered.",
        es: "Ingresaste una fecha a futuro, te regresamos a la ultima fecha que ingresaste.",
    },
    allTrail: {
        en: "All trail",
        es: "Todo el rastro",
    },
    trails: {
        en: "Trails",
        es: "Rastros",
    },
    trail: {
        en: "Trail",
        es: "Rastro",
    },
    detailedTrails: {
        en: "Detailed history",
        es: "Rastro detallado",
    },
    startDate: {
        en: "Initial date",
        es: "Hora inicial",
    },
    endDate: {
        en: "Final date",
        es: "Hora final",
    },
    avgSpeed: {
        en: "Average speed",
        es: "Velocidad promedio",
    },
    elapsedTime: {
        en: "Time lapse",
        es: "Tiempo transcurrido",
    },
    distanceTraveled: {
        en: "Distance traveled",
        es: "Distancia recorrida",
    },
    cleanDisclamer: {
        en: "Are you sure to deselect?",
        es: "Esta seguro que quieres deseleccionar?",
    },
    cleanAll: {
        en: "Deselect",
        es: "Deseleccionar",
    },
    overwrite: {
        en: "Overwrite",
        es: "Sobreescribir",
    },
    merge: {
        en: "Merge",
        es: "Combinar",
    },
    mergeAlert: {
        en: "Tags will be merged by default with the selected ones, no tags will be removed in the merge.",
        es: "Las etiquetas serán combinadas por defecto con las seleccionadas, ninguna etiqueta sera removida.",
    },
    newTag: {
        en: "New Tag",
        es: "Nueva Etiqueta",
    },
    selectPoi: {
        en: "Select",
        es: "Seleccionar",
    },
    advanceFilter: {
        en: "Advanced Filter",
        es: "Filtro Avanzado",
    },
    advancedFilter: {
        en: "Filter by...",
        es: "Filtrar por...",
    },
    advancedFilterMessage: {
        en: "In order to assign/unassign Filter by Task status",
        es: "Para asignar/desasignar Filtre por Estado de tarea",
    },
    advancedFilterMessageDate: {
        en: "You can't assign/unassign tasks in the past",
        es: "No puede asignar/desasignar tareas en el pasado",
    },
    selected: {
        en: "Selected",
        es: "Seleccionados",
    },
    viewAll: {
        en: "View All",
        es: "Ver Todos",
    },
    tag: {
        en: "Tag",
        es: "Etiquetar",
    },
    pastDate: {
        en: "This unit has not had movement today.",
        es: "La unidad no a tenido movimiento el día de hoy.",
    },
    unknownEvent: {
        en: "Unknown Event",
        es: "Evento desconocido",
    },
    event0: {
        en: "Position",
        es: "Posición",
    },
    event1: {
        en: "Movement",
        es: "En Movimiento",
    },
    event2: {
        en: "Engine Off",
        es: "Motor Apagado",
    },
    event3: {
        en: "SOS Button Pressed",
        es: "Pánico",
    },
    event4: {
        en: "TOW",
        es: "Vehículo Remolcado",
    },
    event5: {
        en: "Position Received",
        es: "Posición Recibida",
    },
    event6: {
        en: "Information",
        es: "Información",
    },
    event7: {
        en: "GPS On",
        es: "GPS Encendido",
    },
    event8: {
        en: "GPS Off",
        es: "GPS Apagado",
    },
    event9: {
        en: "Engine On",
        es: "Motor Encendido",
    },
    event10: {
        en: "Low Battery",
        es: "Batería GPS Baja",
    },
    event11: {
        en: "Lost GPS Signal",
        es: "Señal GPS Perdida",
    },
    event12: {
        en: "GPS Signal OK",
        es: "Señal GPS Captada",
    },
    event13: {
        en: "Power Available",
        es: "Energía Disponible",
    },
    event14: {
        en: "Power Not Available",
        es: "Energía No Disponible",
    },
    event15: {
        en: "Collision Detected",
        es: "Colisión Detectada",
    },
    event16: {
        en: "Excessive Idle",
        es: "Estacionado con Motor Encendido",
    },
    event17: {
        en: "In route",
        es: "Entro a la ruta",
    },
    event18: {
        en: "Left route",
        es: "Salió de la ruta",
    },
    event19: {
        en: "Enter Geofence",
        es: "Entro a Geocerca",
    },
    event20: {
        en: "Exit Geofence",
        es: "Salió de Geocerca",
    },
    event21: {
        en: "Min Speed in Geofence",
        es: "Velocidad Minima en Geocerca",
    },
    event22: {
        en: "Over Speed",
        es: "Exceso de Velocidad",
    },
    event23: {
        en: "Authorize Schedule",
        es: "Horario Autorizado",
    },
    event24: {
        en: "Maintenance",
        es: "Mantenimiento",
    },
    event25: {
        en: "Current Position in transit",
        es: "Posición actual en transito",
    },
    event27: {
        en: "Fueling",
        es: "Llenado De Combustible",
    },
    event28: {
        en: "Key Id",
        es: "Llave Id",
    },
    event29: {
        en: "Analog Sensor 1 Connected",
        es: "Sensor Análogo 1 Conectado",
    },
    event30: {
        en: "Analog Sensor 1 Disconnected",
        es: "Sensor Análogo 1 Desconectado",
    },
    event31: {
        en: "Analog Sensor 2 Connected",
        es: "Sensor Análogo 2 Conectado",
    },
    event32: {
        en: "Analog Sensor 2 Disconnected",
        es: "Sensor Análogo 2 Desconectado",
    },
    event33: {
        en: "Analog Sensor 3 Connected",
        es: "Sensor Análogo 3 Conectado",
    },
    event34: {
        en: "Analog Sensor 3 Disconnected",
        es: "Sensor Análogo 3 Desconectado",
    },
    event35: {
        en: "Digital Input 1 Connected",
        es: "Digital Input 1 Conectado",
    },
    event36: {
        en: "Digital Input 1 Disconnected",
        es: "Digital Input 1 Desconectado",
    },
    event37: {
        en: "Digital Input 2 Connected",
        es: "Digital Input 2 Conectado",
    },
    event38: {
        en: "Digital Input 2 Disconnected",
        es: "Digital Input 2 Desconectado",
    },
    event39: {
        en: "Digital Input 3 Connected",
        es: "Digital Input 3 Conectado",
    },
    event40: {
        en: "Digital Input 3 Disconnected",
        es: "Digital Input 3 Desconectado",
    },
    event41: {
        en: "Digital Input 4 Connected",
        es: "Digital Input 4 Conectado",
    },
    event42: {
        en: "Digital Input 4 Disconnected",
        es: "Digital Input 4 Desconectado",
    },
    event43: {
        en: "Temperature Alert",
        es: "Alerta de Temperatura",
    },
    event43min: {
        en: "Low Temperature",
        es: "Temperatura Baja",
    },
    event43max: {
        en: "High Temperature",
        es: "Temperatura Alta",
    },
    event44: {
        en: "Polling...",
        es: "Buscando...",
    },
    event45: {
        en: "Command received",
        es: "Comando recibido",
    },
    event46: {
        en: "Parked",
        es: "Estacionado",
    },
    event47: {
        en: "Sensor Disconnect",
        es: "Sensor Desconectado",
    },
    event48: {
        en: "Sensor Connect",
        es: "Sensor Conectado",
    },
    event49: {
        en: "Unit Dropped",
        es: "Caída",
    },
    event50: {
        en: "Charger connected",
        es: "Cargador conectado",
    },
    event51: {
        en: "Charger disconnected",
        es: "Cargador desconectado",
    },
    event52: {
        en: "GSM Jamming",
        es: "Interferencia Celular",
    },
    event53: {
        en: "OBD disconnected",
        es: "OBD desconectado",
    },
    event54: {
        en: "OBD Connected",
        es: "OBD conectado",
    },
    event55: {
        en: "Harsh braking",
        es: "Frenado brusco",
    },
    event56: {
        en: "Harsh acceleration",
        es: "Aceleración brusca",
    },
    event57: {
        en: "Harsh turning",
        es: "Giro brusco",
    },
    event58: {
        en: "Harsh braking and turn",
        es: "Frenado y giro brusco",
    },
    event59: {
        en: "Harsh acceleration and turn",
        es: "Aceleración y giro brusco",
    },
    event60: {
        en: "Harsh driving",
        es: "Manejo brusco",
    },
    event61: {
        en: "GPS Jamming",
        es: "Interferencia GPS",
    },
    event62: {
        en: "batt_disc_counter",
        es: "batt_disc_counter",
    },
    event63: {
        en: "Open bolt",
        es: "Cerrojo abierto",
    },
    event64: {
        en: "Close Bolt",
        es: "Cerrojo cerrado",
    },
    event65: {
        en: "Door Opened",
        es: "Puerta Abierta",
    },
    event66: {
        en: "Door Opened ",
        es: "Puerta Cerrada",
    },
    event67: {
        en: "Light Sensor",
        es: "Sensor de Luz",
    },
    event68: {
        en: "Close Package",
        es: "Paquete Cerrado",
    },
    event69: {
        en: "Photo Report",
        es: "Reporte de fotografía",
    },
    event70: {
        en: "Decoupled",
        es: "Desacoplado",
    },
    event71: {
        en: "Parking Time Limit",
        es: "Límite de Tiempo Estacionado",
    },
    event72: {
        en: "High Engine Temperature",
        es: "Temperatura de Motor Alta",
    },
    event73: {
        en: "Max Speed in Geofence",
        es: "Velocidad Maxima en Geocerca",
    },
    event74: {
        en: "Severe GPS Jamming",
        es: "Interferencia GPS severa",
    },
    event75: {
        en: "Max Temperature Sensor 2",
        es: "Temperatura Maxima Sensor 2",
    },
    event76: {
        en: "Min Temperature Sensor 1",
        es: "Temperatura Minima Sensor 1",
    },
    event77: {
        en: "Min Temperature Sensor 2",
        es: "Temperatura Minima Sensor 2",
    },
    event78: {
        en: "ECU",
        es: "Información de ECU",
    },
    event79: {
        en: "Open Back Cap",
        es: "Tapa Abierta",
    },
    event80: {
        en: "Steel String Cut",
        es: "Cable Cortado",
    },
    event81: {
        en: "Lock open",
        es: "Candado Abierto",
    },
    event82: {
        en: "Lock close",
        es: "Candado Cerrado",
    },
    event83: {
        en: "Swipe authorization card",
        es: "Tarjeta Autorizada",
    },
    event84: {
        en: "Unauthorized RFID",
        es: "Tarjeta RFID No Valida",
    },
    event85: {
        en: "Vibration Alarm",
        es: "Vibración Detectada",
    },
    event86: {
        en: "Wrong Password",
        es: "Contraseña Incorrecta",
    },
    event87: {
        en: "Dwell",
        es: "Estacionado en zona",
    },
    event91: {
        en: "Irregular Consumption",
        es: "Consumo Irregular",
    },
    event92: {
        en: "Video loss",
        es: "Perdida de video",
    },
    event93: {
        en: "Lens covered",
        es: "Lente obstruido",
    },
    event94: {
        en: "Storage malfunction",
        es: "Error de almacenamiento",
    },
    event95: {
        en: "No driver",
        es: "Sin conductor",
    },
    event96: {
        en: "Phone calling",
        es: "Llamada telefónica",
    },
    event97: {
        en: "Driver smoking",
        es: "Conductor fumando",
    },
    event98: {
        en: "Driver distracted",
        es: "Conductor distraído",
    },
    event99: {
        en: "Lane departure warning",
        es: "Alerta de linea de partida",
    },
    event100: {
        en: "Forward collision warning",
        es: "Alerta de colisión de frente",
    },
    event101: {
        en: "Headway monitoring warning",
        es: "Alerta de monitoreo enfrente",
    },
    event102: {
        en: "Pedestrian collision warning",
        es: "Alerta de colisión con persona",
    },
    event104: {
        en: "Trip Started",
        es: "Empieza Viaje",
    },
    event105: {
        en: "Exited the delivery route",
        es: "Salió de la ruta de entrega",
    },
    event106: {
        en: "Parking safeguard",
        es: "Vigilancia",
    },
    event107: {
        en: "Record Button",
        es: "Botón de Grabación",
    },
    event108: {
        en: "Requested Video",
        es: "Video Solicitado",
    },
    event109: {
        en: "App On",
        es: "App Encendida",
    },
    event110: {
        en: "App Off",
        es: "App Apagada",
    },
    event111: {
        en: "Camera Fault",
        es: "Fallo en Camara",
    },
    event112: {
        en: "Memory Card Fault",
        es: "Fallo en Tarjeta de Memoria",
    },
    event113: {
        en: "Data Usage Limit",
        es: "Limite de Consumo de Datos",
    },
    event114: {
        en: "Impact Alarm",
        es: "Alarma de Impacto",
    },
    event115: {
        en: "Camera Removed",
        es: "Camara Removida",
    },
    eventsDescription1: {
        en: "Movement event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: En Movimiento",
    },
    eventsDescription2: {
        en: "Engine Off event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Motor Apagado",
    },
    eventsDescription3: {
        en: "SOS Button Pressed event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Pánico",
    },
    eventsDescription4: {
        en: "TOW event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Vehículo Remolcado",
    },
    eventsDescription5: {
        en: "Position Received event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Posición Recibida",
    },
    eventsDescription6: {
        en: "Information event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Información",
    },
    eventsDescription7: {
        en: "GPS On event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: GPS Encendido",
    },
    eventsDescription8: {
        en: "GPS Off event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: GPS Apagado",
    },
    eventsDescription9: {
        en: "Engine On event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Motor Encendido",
    },
    eventsDescription10: {
        en: "Low Battery event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Batería GPS Baja",
    },
    eventsDescription11: {
        en: "Lost GPS Signal event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Señal GPS Perdida",
    },
    eventsDescription12: {
        en: "GPS Signal OK event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Señal GPS Captada",
    },
    eventsDescription13: {
        en: "Power Available event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Energía Disponible",
    },
    eventsDescription14: {
        en: "Power Not Available event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Energía No Disponible",
    },
    eventsDescription15: {
        en: "Collision Detected event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Colisión Detectada",
    },
    eventsDescription16: {
        en: "Excessive Idle event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Estacionado con Motor Encendido",
    },
    eventsDescription17: {
        en: "In route event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Entro a la ruta",
    },
    eventsDescription18: {
        en: "Left route event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Salió de la ruta",
    },
    eventsDescription19: {
        en: "{description} has entered the geofence {name}",
        es: "{description} entró a la geocerca {name}",
    },
    eventsDescription20: {
        en: "{description} has left the geofence {name}",
        es: "{description} salió de la geocerca {name}",
    },
    eventsDescription21: {
        en: "Min Speed in Geofence event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Velocidad Minima en Geocerca",
    },
    eventsDescription22: {
        en: "Over Speed event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Exceso de Velocidad",
    },
    eventsDescription23: {
        en: "Schedule Alert event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Actividad Fuera de Horario Autorizado",
    },
    eventsDescription24: {
        en: "Maintenance event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Mantenimiento",
    },
    eventsDescription25: {
        en: "Current Position in transit event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Posición actual en transito",
    },
    eventsDescription27: {
        en: "Fueling event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Llenado De Combustible",
    },
    eventsDescription28: {
        en: "Key Id event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Llave Id",
    },
    eventsDescription29: {
        en: "Analog Sensor 1 Connected event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Sensor análogo 1 Conectado",
    },
    eventsDescription30: {
        en: "Analog Sensor 1 Disconnected event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Sensor análogo 1 Desconectado",
    },
    eventsDescription31: {
        en: "Analog Sensor 2 Connected event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Sensor análogo 2 Conectado",
    },
    eventsDescription32: {
        en: "Analog Sensor 2 Disconnected event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Sensor análogo 2 Desconectado",
    },
    eventsDescription33: {
        en: "Analog Sensor 3 Connected event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Sensor análogo 3 Conectado",
    },
    eventsDescription34: {
        en: "Analog Sensor 3 Disconnected event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Sensor análogo 3 Desconectado",
    },
    eventsDescription35: {
        en: "{inputDescription} event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: {inputDescription}",
    },
    eventsDescription36: {
        en: "{inputDescription} event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: {inputDescription}",
    },
    eventsDescription37: {
        en: "{inputDescription} event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: {inputDescription}",
    },
    eventsDescription38: {
        en: "{inputDescription} event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: {inputDescription}",
    },
    eventsDescription39: {
        en: "{inputDescription} event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: {inputDescription}",
    },
    eventsDescription40: {
        en: "{inputDescription} event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: {inputDescription}",
    },
    eventsDescription41: {
        en: "{inputDescription} event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: {inputDescription}",
    },
    eventsDescription42: {
        en: "{inputDescription} event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: {inputDescription}",
    },
    eventsDescription43: {
        en: "Temperature Alert event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Alerta de Temperatura.",
    },
    eventsDescription43min: {
        en: "{description} has a temperature of {temperature} (min: {temperatureLimit}), generated by {device}, ",
        es: "{description} tiene una temperatura de  {temperature} (min: {temperatureLimit}), generado por {device}, ",
    },
    eventsDescription43max: {
        en: "{description} has a temperature of {temperature} (max: {temperatureLimit}), generated by {device}, ",
        es: "{description}  tiene una temperatura de {temperature} (max: {temperatureLimit}),  generado por {device}, ",
    },
    eventsDescription44: {
        en: "Polling... event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Buscando...",
    },
    eventsDescription45: {
        en: "Command received event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Comando recibido",
    },
    eventsDescription46: {
        en: "Parked event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Estacionado",
    },
    eventsDescription47: {
        en: "Sensor Disconnect event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Sensor Desconectado",
    },
    eventsDescription48: {
        en: "Sensor Connect event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Sensor Conectado",
    },
    eventsDescription49: {
        en: "Unit Dropped event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Caída",
    },
    eventsDescription50: {
        en: "Charging Battery event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Cargando batería",
    },
    eventsDescription51: {
        en: "Charger disconnected event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Cargador desconectado",
    },
    eventsDescription52: {
        en: "GSM Jamming event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Interferencia Celular",
    },
    eventsDescription53: {
        en: "OBD disconnected event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: OBD desconectado",
    },
    eventsDescription54: {
        en: "OBD Connected event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: OBD conectado",
    },
    eventsDescription55: {
        en: "Harsh braking event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Frenada brusca",
    },
    eventsDescription56: {
        en: "Harsh acceleration event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Aceleración brusca",
    },
    eventsDescription57: {
        en: "Harsh cornering event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Movimiento brusco",
    },
    eventsDescription58: {
        en: "Harsh Braking and Turn event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Frenado y Giro Brusco",
    },
    eventsDescription59: {
        en: "Harsh Acceleration and Turn event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Aceleración y Giro Brusco",
    },
    eventsDescription60: {
        en: "Harsh Behavior event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Comportamiento Brusco",
    },
    eventsDescription61: {
        en: "GPS Jamming event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Interferencia GPS",
    },
    eventsDescription62: {
        en: "batt_disc_counter event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: batt_disc_counter",
    },
    eventsDescription63: {
        en: "Open bolt event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Cerrojo abierto",
    },
    eventsDescription64: {
        en: "Close Bolt event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Cerrojo cerrado",
    },
    eventsDescription65: {
        en: "Door Opened event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Puerta Abierta",
    },
    eventsDescription66: {
        en: "Door Opened  event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Puerta Cerrada",
    },
    eventsDescription67: {
        en: "Open Package event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Paquete Abierto",
    },
    eventsDescription68: {
        en: "Close Package event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Paquete Cerrado",
    },
    eventsDescription69: {
        en: "PhotoReport event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: PhotoReport",
    },
    eventsDescription70: {
        en: "Decoupled event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Desacoplado",
    },
    eventsDescription71: {
        en: "Parking Time Limit event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Límite de Tiempo Estacionado ",
    },
    eventsDescription72: {
        en: "High Engine Temperature event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Temperatura de Motor Alta",
    },
    eventsDescription73: {
        en: "Max Speed in Geofence event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Velocidad Maxima en Geocerca",
    },
    eventsDescription74: {
        en: "Severe GPS Jamming event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Interferencia GPS severa",
    },
    eventsDescription75: {
        en: "Max Temperature Sensor 2 event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Temperatura Maxima Sensor 2",
    },
    eventsDescription76: {
        en: "Min Temperature Sensor 1 event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Temperatura Minima Sensor 1",
    },
    eventsDescription77: {
        en: "Min Temperature Sensor 2 event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Temperatura Minima Sensor 2",
    },
    eventsDescription78: {
        en: "ECU event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Información de ECU",
    },
    eventsDescription79: {
        en: "Open Back Cap event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Tapa Abierta",
    },
    eventsDescription80: {
        en: "Steel String Cut event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Cable Cortado",
    },
    eventsDescription81: {
        en: "Lock open event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Candado Abierto",
    },
    eventsDescription82: {
        en: "Lock close event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Candado Cerrado",
    },
    eventsDescription83: {
        en: "Swipe authorization card event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Tarjeta Autorizada",
    },
    eventsDescription84: {
        en: "Unauthorized RFID event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Tarjeta RFID No Valida",
    },
    eventsDescription85: {
        en: "Vibration Alarm event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Vibración Detectada",
    },
    eventsDescription86: {
        en: "Wrong Password event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Contraseña Incorrecta",
    },
    eventsDescription87: {
        en: "Dwell event produced by {description}, in geofence {name}.",
        es: "Se genero un evento de la unidad {description}: Estacionado en zona, geocerca {name}.",
    },
    eventsDescription91: {
        en: "Irregular Consumption event produced by {description}.",
        es: "Se genero un evento de la unidad {description}: Consumo Irregular",
    },
    eventsDescription92: {
        en: "Video loss event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Perdida de video.",
    },
    eventsDescription93: {
        en: "Lens covered event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Lente obstruido.",
    },
    eventsDescription94: {
        en: "Storage malfunction event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Error de almacenamiento.",
    },
    eventsDescription95: {
        en: "No driver event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Sin conductor.",
    },
    eventsDescription96: {
        en: "Phone calling event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Llamada telefónica.",
    },
    eventsDescription97: {
        en: "Driver smoking event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Conductor fumando.",
    },
    eventsDescription98: {
        en: "Driver distracted event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Conductor distraído.",
    },
    eventsDescription99: {
        en: "Lane departure warning event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Alerta de linea de partida.",
    },
    eventsDescription100: {
        en: "Forward collision warning event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Alerta de colisión de frente.",
    },
    eventsDescription101: {
        en: "Headway monitoring warning event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Alerta de monitoreo enfrente.",
    },
    eventsDescription102: {
        en: "Pedestrian collision warning event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Alerta de colisión con persona.",
    },
    eventsDescription104: {
        en: "Trip started warning event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Alerta de empieza viaje.",
    },
    eventsDescription105: {
        en: "Exited the delivery route warning event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Salió de la ruta de entrega",
    },
    eventsDescription106: {
        en: "Parking safeguard event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Vigilancia",
    },
    eventsDescription107: {
        en: "Record Button event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Botón de Grabación",
    },
    eventsDescription108: {
        en: "Requested Video event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Video Solicitado",
    },
    eventsDescription109: {
        en: "App On event produced by {description}.",
        es: "Se generó un evento de la unidad {description}: App Encendida",
    },
    eventsDescription110: {
        en: "App Off event produced by {description}.",
        es: "Se generó un evento de la unidad {description}: App Apagada",
    },
    eventsDescription111: {
        en: "Camera Fault event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Fallo en Camara.",
    },
    eventsDescription112: {
        en: "Memory Card Fault event producen by {description}.",
        es: "Se genero un evento de la unidad {description}: Fallo en Tarjeta de Memoria.",
    },
    eventsDescription113: {
        en: "You’ve reached {percentage} of your data plan for {description}! Keep an eye on your usage or upgrade to avoid disruptions..",
        es: "¡Has alcanzado el {percentage} de tu plan de datos para {description}! Monitorea tu uso, ó actualiza tu plan para evitar interrupciones..",
    },
    eventsDescription114: {
        en: "Impact alarm event by {description}.",
        es: "Se genero un evento de la unidad {description}: Alarma de impacto.",
    },
    eventsDescription115: {
        en: "Interior camera removed event by {description}.",
        es: "Se genero un evento de la unidad {description}: Camara interior removida.",
    },
    eventMaxSpeed: {
        en: "Over Speed, the limit speed is: ",
        es: "Exceso de velocidad, el limite de velocidad es: ",
    },
    eventMaxTemperature: {
        en: "{description} is over the temperature limit.",
        es: "{description} se encuentra sobre el limite de temperatura permitido",
    },
    eventOverSpeedOnGeofence: {
        en: "Over Speed in Geofence: {geofence}, the limit is: ",
        es: "Exceso de velocidad en Geocerca: {geofence}, el limite de velocidad es: ",
    },
    eventMinTemperature: {
        en: "{description} is below the temperature limit.",
        es: "{description} se encuentra debajo el limite de temperatura permitido",
    },
    temperatureValue: {
        en: "Actual: ",
        es: "Lectura: ",
    },
    limit: {
        en: "Limit: ",
        es: "Limite: ",
    },
    individual: {
        en: "Individual",
        es: "Individual",
    },
    convoy: {
        en: "Group",
        es: "Grupo",
    },
    map: {
        en: "Map",
        es: "Mapa",
    },
    maps: {
        en: "Maps",
        es: "Mapas",
    },
    connected: {
        en: "Connected",
        es: "Conectado",
    },
    vin: {
        en: "VIN",
        es: "VIN",
    },
    engineCoolantTemperatureInC: {
        en: "Coolant temperature",
        es: "Temperatura del coolant",
    },
    engineLoad: {
        en: "Engine Load",
        es: "Carga de motor",
    },
    engineRevolutionsPerMinute: {
        en: "Revolutions",
        es: "Revoluciones",
    },
    fuelConsumptionLKM: {
        en: "Fuel Consumption",
        es: "Consumo de Combustible",
    },
    fuelLevelInput: {
        en: "Fuel",
        es: "Combustible",
    },
    malfunctionIndicatorStatus: {
        en: "Malfunction Status",
        es: "Estado de mal funcionamiento",
    },
    milage: {
        en: "Milage",
        es: "Kilometraje",
    },
    numberOfDTCs: {
        en: "DTCs",
        es: "DTCs",
    },
    powerVoltageInmV: {
        en: "Voltage",
        es: "Voltaje",
    },
    throttlePosition: {
        en: "Throttle Position",
        es: "Posición de acelerador",
    },
    obdButton: {
        en: "OBD",
        es: "OBD",
    },
    obdTitle: {
        en: "OBD Data",
        es: "Datos de OBD",
    },
    deviceInformation: {
        en: "Units information",
        es: "Información de unidades",
    },
    extraInformation: {
        en: "Extra information",
        es: "Información extra",
    },
    createDisplacementAlert: {
        en: "Create Displacement Alert.",
        es: "Crear Alerta de Desplazamiento.",
    },
    nearestTitle: {
        en: "Closest Units",
        es: "Unidades cercanas",
    },
    noDevicesFound: {
        en: "There are no units in a radio of {radio}.",
        es: "No hay unidades dentro de un radio de {radio}.",
    },
    shareWithDriver: {
        en: "Share with {name}.",
        es: "Compartir con {name}.",
    },
    requestVideo: {
        en: "Request Video",
        es: "Obtener Video",
    },
    viewVideo: {
        en: "View Video",
        es: "Ver Video",
    },
    selectCamera: {
        en: "Select a Camera",
        es: "Selecciona una Camara",
    },
    sendRequest: {
        en: "Send Request",
        es: "Enviar Petición",
    },
    position: {
        en: "Position",
        es: "Posición",
    },
    commandReceived: {
        en: "Command received",
        es: "Comando recibido",
    },
    requestPhoto: {
        en: "Request Photo",
        es: "Obtener Fotografía",
    },
};
exports.default = translations;
